import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class ContainerDefinitionService {
  constructor(private apiHttp: ApiHttpService) {}

  public getFlats = (): Observable<ContainerDefinition[]> => {
    return this.apiHttp.get<ContainerDefinition[]>("containerdefinitions/flats");
  };

  public getPots = (): Observable<ContainerDefinition[]> => {
    return this.apiHttp.get<ContainerDefinition[]>("containerdefinitions/pots");
  };

  public get = (id: number): Observable<ContainerDefinition> => {

    return this.apiHttp.get<ContainerDefinition>(`containerdefinitions/${id}`);
  };
}

export interface ContainerDefinition {
  id: number;
  name: string;
  isActive: boolean;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/container-definition.service.ts